import { useState } from "react";
import Input from '@/components/Input';
import Button from '@/components/Button';
import axios from "axios";
import LanguageIcon from '@mui/icons-material/Language';
import { saveUser } from "@/utils/User";
import { useSession } from '@toolpad/core/useSession';
import { checkPasswordConditions, getErrorMessage } from '@/utils/Errors';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import { styleCards } from '@/utils/Styles';

// to recover password or to reset if forced to change it
export default function Reset({t,language,user,router,token,apiUrl,sendMessage,handleLogin,embedded}){

	const { sxCard } = styleCards();

	const session = useSession();

	const [data, setData] = useState({
        password: null,
        password2: null
    });

	const handleInput = (e) => {

        var name = e.target.name;
        var value = e.target.value;

        if(name === 'password'){
        	setData({password:value,password2:data?.password2});
        }
        else{
        	setData({password:data?.password,password2:value});
        }
    };

	// submit with enter
    const handleKeyDown = (e) => {
		if (event.key === 'Enter') {
			handleSubmit(e);
		}
	}

	// forgot password
	const handleSubmit = () => {

		const password = data?.password;
		const password2 = data?.password2;

		var error = false;
		if(!password || password.length === 0 || !password2 || password2.length === 0){
			error = true;
			sendMessage(t('password.errors.empty'),'error');
		}
		else{
			if(password !== password2){
				error = true;
				sendMessage(t('password.errors.notequal'),'error');
			}
			else{
				const errors = checkPasswordConditions(password);
				const keys = Object.keys(errors); 				
				if(keys && keys?.length > 0){
					error = true;
					const errorPassword = getErrorMessage(t,'password',errors);
					sendMessage(errorPassword,'error');
				}
			}
		}

		if(!error){

            const apiPath = '/reset';

	        const config = {
            	headers: { Authorization: `Bearer ${token}` } 
        	};

	        const send = {
	            language: language,	 
	            companyuser: user?.company,
	            password:data.password,
	            password2:data.password2
	        };

            var errorMessage = t('reset.error');
            const url = apiUrl+apiPath;
            
            axios.post(url,send,config)
            .then(function (response) {
                    
                if(response?.data){
              
                    var responseData = response.data;

                    // if result is ok (1)                
                    if(responseData?.result){                      	
                        
                        sendMessage(t('reset.passwordchanged'));

                        // clean values
					    setData({password:'',password2:''});
                        
                        // if not embedded on another page (profile for example)                        
                        if(!embedded){

                        	// update user   
					        user.reset = 0;
					        saveUser(user);
					        session?.setUser(user);					        
					        
					        //window.location.reload();
					        // to force "refresh" and remove the warning
					        // just in case we are already on /				        
					        if(router.pathname === '/'){
					        	router.navigate('/profile');
					    	}
					    	else{
					    		router.navigate('/');
					    	}
					    }
                    } 
                    else{

                    	if(responseData?.status && responseData.status === 401){
	                        handleLogin();
	                    }
	                    else{ 

	                        // check error message
	                        if(responseData?.data?.reasons){      
	                        	errorMessage = getErrorMessage(t,'password',responseData?.data?.reasons);
	                        }
	                        
	                        sendMessage(errorMessage,'error');    
	                    }                    
                    }
                }
                else{
                    sendMessage(errorMessage,'error');   
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(t('reset.error'),'error');
                }
            });
		}
	}

 	return (
 		<Card sx={sxCard}>
            <CardContent>    	

	    		<div id='reset-title'>
	        		{t('reset.title')}
	        	</div>

	        	{
	        		!embedded &&
	        		<div id='reset-description'>
	        			{t('reset.description')}
	        		</div>
	        	}
	          
	          	<form id='reset-form'>
	            	
	            	<div>
	              		<div className="mt-2">             			
		                	<Input	     
			                	className='reset-input'               
			                    name="password"
			                    type="text"
			                    value={data?.password}	                    
			                    placeholder={t('reset.password')}
			                    autoComplete="email"
			                    onChange={handleInput}
			                    error=''
			        			handleKeyDown={handleKeyDown}
			        			variant='filled'
		                	/>
	              		</div>
	            	</div>

	            	<div>
	              
	              		<div className="mt-6">		              			
	                		<Input	             
			                	className='reset-input'       
			                    name="password2"
			                    type="text"
			                    value={data?.password2}	                    
			                    placeholder={t('reset.password2')}
			                    autoComplete="password"
			                    onChange={handleInput}
			                    error=''
			        			handleKeyDown={handleKeyDown}
			        			variant='filled'
	                		/>			                	
	              		</div>		              		

	            	</div>

	            	<div className='flex justify-center mt-8'>

		            	<div className='ml-2'>		            		
		              		<Button
		                		type="reset"
		                		variant="contained"
		                		text={t("reset.button")}
		                		onClick={handleSubmit}
		              		/>			              	
		            	</div>
		            </div>

	          	</form>

	    	</CardContent>
	    </Card>
  	)
}
